// extracted by mini-css-extract-plugin
export default {"universeBackground":"style_universeBackground__jxe6C","landingPage":"style_landingPage__bz5Bh","responsivePlanetBackground":"style_responsivePlanetBackground__jESyK"};